import React, { useEffect, useState } from "react";

import { Grid, Container } from "@material-ui/core";
import { DialogSystemGLPure, ButtonHLPure, SubtitlePageHLPure, TextAreaHLPure, SimpleLoading } from "../../pures";
import "./questionnaires-administration-disable.css"
import { QuestionnaireService, ContractService } from "../../../services";
import { useTranslation } from "react-i18next";
import { NIL as NIL_UUID } from 'uuid';

const QuestionnairesAdministrationDisableView = ({
  user,
  token,
  selectedQuestion,
  selectedQuestionnaire,
  hideShowDetails,
  toggleShowDetailComponent,
  showDetailComponent,
  toggleCompleteRequest,
  setStateNameComponentUser,
  setShowDetails,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  setNameComponentUser
}) => {

  const { t } = useTranslation();

  const [comments, setComments] = useState("");
  const [message, setMessage] = useState("")
  const [showGettingData, setShowGettingData] = useState(false);
  const [nameQuestionnaire, setNameQuestionnaire] = useState('')

  useEffect(() => {
    toggleLoadingRequesting(true)
    if (selectedQuestionnaire && selectedQuestionnaire.name) {
      let name = selectedQuestionnaire && selectedQuestionnaire.name ? selectedQuestionnaire.name : ''
      setNameQuestionnaire(name)
      toggleLoadingRequesting(false)
    }
  }, [selectedQuestionnaire])

  const handleChangeComments = (e) => {
    setComments(e.target.value);
  };

  const handleSave = async () => {
    toggleLoadingRequesting(true)
    let userId = user.userMetaData.userA3Cloud.clientId;

    //duplicate questionnaire
    let contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API);
    let id = selectedQuestionnaire.id
    let description = comments
    let status = !selectedQuestionnaire.active
    let messageError = selectedQuestionnaire.active === true ? 'Ocurrió un error al inhabilitar el cuestionario' : 'Ocurrió un error al habilitar el cuestionario'
    try {
      let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
      let questionnaireDisable = await questionnaireService.updateQuestionnaireStatus(id, description, status, token)
      if (questionnaireDisable && questionnaireDisable.statusCode === 200) {
        let questionnaires = await contractService.getQuestionnairesByUserId(token, userId)
        await toggleLoadingRequesting(false)
        await toggleCompletedRequesting(true, '', questionnaires.data.data)
        setTimeout(() => {
          hideShowDetails()
        }, 4000)
      } else {
        setMessage(messageError)
        toggleErrorRequesting(true)
        setTimeout(() => {
          toggleErrorRequesting(false)
        }, 3000)
      }
    } catch (error) {
      setMessage(messageError)
      toggleErrorRequesting(true)
      setTimeout(() => {
        toggleErrorRequesting(false)
      }, 3000)
    }
  };

  if (showGettingData) return <SimpleLoading />
  return (
    <div className="questionnairesAdministrationDisableView-wrapper">
      <Container>
        <Grid
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <div className="questionnairesAdministrationDisableView-body">
            <div className="questionnairesAdministrationDisableView-items">
              <div className="questionnairesAdministrationDisableView-textAreaHLPure">
                <TextAreaHLPure
                  labelTextArea={
                    selectedQuestionnaire.active
                      ? `${t("digitalContractDashboard.questionnaires.disableReason")} * ` + "" + nameQuestionnaire
                      : " Motivo de habilitación*" + "" + nameQuestionnaire
                  }
                  valueTextData={comments}
                  handleChangeTextArea={(e) => handleChangeComments(e)}
                />
              </div>
              <div className="questionnairesAdministrationDisableView-btnGroup" >
                <ButtonHLPure
                  nameBtn={t("button.return")}
                  onClickBtn={showDetailComponent ? toggleShowDetailComponent : hideShowDetails}
                />
                <ButtonHLPure
                  primary
                  nameBtn={selectedQuestionnaire.active ? t("questionnairesAdministrationView.grid.disable") : t("questionnairesAdministrationView.btn.enable")}
                  onClickBtn={handleSave}
                />
              </div>
            </div>
          </div>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={message}
          />
        </Grid>
      </Container>
    </div>
  )
};

export default QuestionnairesAdministrationDisableView;
